import React, { useState, useEffect } from "react";
import "../../../assets/css/customer/shop/components/pl_SearchBar.css";

const sortOptions = [
  { id: 1, label: "Featured", value: "featured" },
  { id: 2, label: "Price: Low to High", value: "price-asc" },
  { id: 3, label: "Price: High to Low", value: "price-desc" },
  { id: 4, label: "Newest First", value: "newest" },
  { id: 5, label: "Best Rating", value: "rating" },
  { id: 6, label: "Most Popular", value: "popular" },
];

const SearchBar = ({ onSearch, onSort, totalProducts }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("featured");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [showSortDropdown, setShowSortDropdown] = useState(false);

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
  };

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery, onSearch]);

  // Handle sort change
  const handleSortChange = (value) => {
    setSortBy(value);
    onSort(value);
    setShowSortDropdown(false);
  };

  // Clear search
  const clearSearch = () => {
    setSearchQuery("");
    onSearch("");
  };

  // Get selected sort label
  const getSelectedSortLabel = () => {
    const selected = sortOptions.find((option) => option.value === sortBy);
    return selected ? selected.label : "Sort By";
  };

  return (
    <div className="pl-search-bar">
      {/* Search Section */}
      <div className="pl-search-container">
        <div
          className={`pl-search-wrapper ${isSearchFocused ? "pl-search-focused" : ""}`}
        >
          {/* Search Icon */}
          <svg
            className="pl-search-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>

          {/* Search Input */}
          <input
            type="text"
            className="pl-search-input"
            placeholder="Search furniture..."
            value={searchQuery}
            onChange={handleSearchChange}
            onFocus={() => setIsSearchFocused(true)}
            onBlur={() => setIsSearchFocused(false)}
          />

          {/* Clear Button */}
          {searchQuery && (
            <button
              className="pl-search-clear"
              onClick={clearSearch}
              aria-label="Clear search"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
        </div>

        {/* Search Results Count */}
        {searchQuery && (
          <p className="pl-search-results">
            Found <strong>{totalProducts}</strong> product
            {totalProducts !== 1 ? "s" : ""}
          </p>
        )}
      </div>

      {/* Sort Section */}
      <div className="pl-sort-container">
        {/* Products Count */}
        <p className="pl-products-count">
          <strong>{totalProducts}</strong> Products
        </p>

        {/* Sort Dropdown */}
        <div className="pl-sort-wrapper">
          <button
            className="pl-sort-button"
            onClick={() => setShowSortDropdown(!showSortDropdown)}
          >
            <svg
              className="pl-sort-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
              />
            </svg>
            <span className="pl-sort-label">{getSelectedSortLabel()}</span>
            <svg
              className={`pl-sort-chevron ${showSortDropdown ? "pl-sort-chevron-open" : ""}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {/* Dropdown Menu */}
          {showSortDropdown && (
            <div className="pl-sort-dropdown">
              {sortOptions.map((option) => (
                <button
                  key={option.id}
                  className={`pl-sort-option ${sortBy === option.value ? "pl-sort-active" : ""}`}
                  onClick={() => handleSortChange(option.value)}
                >
                  {option.label}
                  {sortBy === option.value && (
                    <svg
                      className="pl-check-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
